import moment from 'moment';
import _ from 'lodash';

import { MONTH_LIST } from '../../constants';

const useExpenseReport = (accountList, expenseTransactions, year, livingExpenseOnly, usd, exchangeRate, reportView, livingExpenseExempt = []) => {
	const startDate = moment(`${year}-01-01`).format('YYYY-MM-DD');
	const endDate = moment(`${year}-12-31`).format('YYYY-MM-DD');
	let expenseReport = [];
	let totalMonthExpenseSum = [];
	let totalExpenseSum = 0;

	const isUsdAccount = (account) => {
		const accountItem = accountList.find(i => i.name === account);
		if (accountItem.currency === 'USD') {
			return true;
		}

		return false;
	};

	const getMonthFiltered = (data, key, month) => {
		const filtered = data[key].filter(i => i.date.substr(5, 2) === month);

		if (filtered.length > 0) {
			return filtered.map(i => isUsdAccount(i.account) ? (i.amount * exchangeRate):i.amount).reduce((a, b) => a + b);
		}

		return 0;
	};

	if (expenseTransactions.length > 0) {
		const groupedExpenseData = _
			.chain(expenseTransactions.filter(k => k.date >= startDate &&  k.date <= endDate))
			.groupBy(x => {
				if (reportView === 'category') {
					return x.category;
				}
				return x.subcategory ? `${x.category}:${x.subcategory}` : x.category;
			})
			.value();

		expenseReport = Object.keys(groupedExpenseData).map(key => {
			return {
				category: key,
				month: MONTH_LIST.map(i => getMonthFiltered(groupedExpenseData, key, i)),
				sum: groupedExpenseData[key].map(i => isUsdAccount(i.account) ? (i.amount * exchangeRate):i.amount).reduce((a, b) => a + b)
			};
		}).sort((a, b) => {
			const aHasParent = a.category.includes(':');
			const bHasParent = b.category.includes(':');

			if (aHasParent && !bHasParent) {
				return -1;
			}
			if (!aHasParent && bHasParent) {
				return 1;
			}

			const categoryA = a.category.toLowerCase();
			const categoryB = b.category.toLowerCase();
			return categoryA.localeCompare(categoryB);
		});

		if (livingExpenseOnly) {
			expenseReport = expenseReport.filter(i => !livingExpenseExempt.find(j => i.category && i.category.startsWith(j)));
		}
		if (expenseReport.length > 0) {
			totalMonthExpenseSum = MONTH_LIST.map((m, index) => expenseReport.map(i => i.month[index]).reduce((a, b) => a + b));
			totalExpenseSum = expenseReport.map(i => i.sum).reduce((a, b) => a + b);
		}
	}
    
	return { expenseReport, totalMonthExpenseSum, totalExpenseSum };
};

export default useExpenseReport;